var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-search-results-empty",attrs:{"data-testid":"search-results-empty"}},[_c('Icon',{attrs:{"name":_vm.iconClassEnum.SEARCH}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('label.no_results')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }